import { render, staticRenderFns } from "./DemoDataTable.vue?vue&type=template&id=399fb1d9&"
import script from "./DemoDataTable.vue?vue&type=script&lang=js&"
export * from "./DemoDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports